
<!-- 

LISTA DE PESQUISA DE PRODUTOS E PRECOS


URL SOMENTE PRODUTOS ATIVOS


 -->


<script>

import BarList from '../components/bar-list'
import AnexosForm from '../components/anexos-form'
import { getText, formatDate } from '../shared/utils'
import { SysVars } from '../main';

export default {
    data () {

        return {
            crud: '', //indica o modo de edicao: incluir, alterar, visualizar, etc
            coditem: '',
            descricao: '', 
            metadata: this.$store.getters.getEntities.metadata,
            filter: '',
            showAnexosForm: false,
            offset: false,
            tabelas: [
                {
                    codtabpre: '1',
                    descricao: 'Padrão'
                }
            ],
        }
    },

    computed: {
        nextPage: function () {
            return this.$store.getters.getNextPage
        },

        produtos: function () {
            return this.$store.getters.getItemSalesList
        },

        tabelasUsuario: function () {
            //monta objeto de tabelas de preco conforme permissao do usuario (usuario.parametros.vendas.tabelaspreco)
            let tabelas = this.$store.getters.getTabpreList.filter((obj) => { return obj.sttabpre == 'A' } )
            return tabelas

            // let options = []

            // let liberado = []
            // let currTabpre = {}

            // for (var x = 0; x < this.$store.getters.getTabpreList.length; x++) {
            //     currTabpre = this.$store.getters.getTabpreList[x]

            //     //se existir parametros do usuario, libera somente as tabelas permitidas
            //    if (this.$store.getters.getParametrosUsuario && this.$store.getters.getParametrosUsuario.vendas) {
            //         liberado = this.$store.getters.getParametrosUsuario.vendas.tabelaspreco.filter((obj) => { return obj == currTabpre.codtabpre})
            //         if (liberado.length > 0) {
            //             options.push({ id: currTabpre.codtabpre, text: currTabpre.descricao })
            //         }
            //     } else {
            //         options.push({ id: currTabpre.codtabpre, text: currTabpre.descricao })
            //     }
            // }
            // return options
        },

    },

    methods: {
        handleAnexosForm (coditem, descricao) {
            this.coditem = coditem
            this.descricao = descricao
            this.showAnexosForm = true
        },

        handleMore () {
            this.offset = true
            this.loadData()
        },

        closeForm() {
            this.showAnexosForm = false
        },

        search(value) {
            //efetua a pesquisa
            this.filter = '{"$or":[{"codigo":{"$eq":"' + value + '"}},{"descricao":{"$like":"%25' + value + '%25"}}]}'
            this.loadData()
        },

        textST (value) {
            return getText(value, this.metadata.item.stitem)
        },

        async loadData() {
            await this.$store.dispatch('loadTabpre', {}) 

            let params = { filter: this.filter }
            if (this.offset) {
                params.offset = this.nextPage
            }
            this.$store.dispatch('loadPesquisaProdutosSales', params )
            this.offset = false
        }

    },

    components: {
        BarList, AnexosForm
    },

    created () {
        this.loadData()
    }

}

</script>

<template>
    <div>
        <div id="list"> 
            <bar-list
                :refresh-button="true" 
                :xls-button="true"
                single-entity="" 
                plural-entity="Pesquisa de Produtos"
                @search="search"
                @refresh="loadData"
                title-search="Pesquise pelo código ou pela descrição do produto">
            </bar-list>
            <br>
            <div class="default-container">
                <alert v-if="produtos.length == 0" type="norecord"></alert>
                <div class="mainbox" v-for="(produto, index) in produtos" :key="index">
                    <div class="box">
                        <div class="row align-items-center" style="font-weight: 500" v-if="index==0">
                            <div class="col-md-1 col-1 d-none d-md-block">
                            </div>
                            <div class="col-md-4 col-6">
                                <span class="lbl-list">Descrição</span>
                            </div>
                            <div class="col-md-1 col-3" style="float: left">
                                <label class="lbl-list">Código</label>
                            </div>
                            <div class="col-md-2 col-2 text-center d-none d-md-block" style="float: left">
                                <label class="lbl-list">Entradas</label>
                            </div>
                            <div class="col-md-2 col-2 text-center d-none d-md-block" style="float: left">
                                <label class="lbl-list">Saídas</label>
                            </div>
                            <div class="col-md-2 col-3 text-center" style="float: left">
                                <label class="lbl-list">Saldo</label>
                            </div>
                            <!-- <div class="col-md-1 col-2">
                                <label class="lbl-list">NCM</label>
                            </div>
                            <div class="col-md-1 col-2">
                                <label class="lbl-list">Estoque</label>
                            </div>
                            <div class="col-md-1 col-2" v-for="(tab, index) in tabelasUsuario" :key="index">
                                 <span class="lbl-list float-right" :title="tab.descricao">{{ tab.descricao }}</span>
                            </div> -->
                        </div>

                        <div class="row align-items-center" style="font-size: 12px;">
                            <div class="col-md-1 col-1 text-center d-none d-md-block">
                                <img v-if="produto.url" :src="produto.url" class="mx-auto d-block img-thumbnail" alt="Logotipo" style="max-width: 45px; max-height: 45px; cursor: pointer;">
                                <i v-if="!produto.url" class="fa fa-camera mx-auto d-block" style="font-size: 25px; color: silver"></i>
                            </div>
                            <div class="col-md-4 col-6">
                                <span class="data-list">{{ produto.descricao }}</span>
                            </div>
                            <div class="col-md-1 col-3">
                                <span class="data-list-sm">{{ produto.codigo }}</span>
                            </div>
                            <div class="col-md-2 col-2 text-center d-none d-md-block">
                                <span class="data-list-sm">{{ produto.qtent | formatValue(2) }}</span>
                            </div>
                            <div class="col-md-2 col-2 text-center d-none d-md-block">
                                <span class="data-list-sm">{{ produto.qtsai | formatValue(2) }}</span>
                            </div>
                            <div class="col-md-2 col-3 text-center">                                
                                <span v-if="((produto.qtent - produto.qtsai) > 0)" class="data-list-sm lbl-green">{{ (produto.qtent - produto.qtsai) | formatValue(2) }}</span>                            
                                <span v-else="((produto.qtent - produto.qtsai) < 0)" class="data-list-sm lbl-red">{{ (produto.qtent - produto.qtsai) | formatValue(2) }}</span>                                
                            </div>
                            <!-- <div class="col-md-1 col-2">
                                <span class="data-list-sm">{{ produto.ncm }}</span>
                            </div>
                            <div class="col-md-1 col-2">
                                <span class="data-list-sm">{{ produto.qtest }} <small>{{ produto.uni }}</small></span>
                            </div>
                            <div class="col-md-1 col-2" v-for="(tab, index) in produto.tabelas_preco.tabelas" :key="index">
                                <span class="data-list-sm float-right"><small>R$</small> {{ tab.vlr | formatValue(2) }}</span>
                            </div> -->
                        </div>
                    </div>
                </div>
                <div>
                    <a v-if="nextPage>0" style="cursor: pointer; color: #0091ea;" @click="handleMore()">Exibir mais</a>
                </div>
            </div>
        </div>
        <anexos-form v-if="showAnexosForm" :params="{ ref: 'item', chaveref: coditem, title: descricao, showform: true }" @closeform="closeForm"></anexos-form>
    </div>
</template>

<style>

</style>








// WEBPACK FOOTER //
// src/forms/item-entradas-saidas.vue